// Campos numéricos "livres" (área, m² etc) - o usuário pode digitar com
// vírgula (formato brasileiro, "77,52") ou ponto ("77.52"). O input em si
// só filtra caracteres inválidos enquanto digita (sanitizeDecimalKeystroke);
// a conversão pra número de verdade (parseDecimalInput) só acontece na
// hora de montar o payload pro backend - assim o campo nunca trava o
// usuário no meio da digitação.

// Filtra o texto digitado: só dígitos e um único separador decimal
// (vírgula ou ponto) - remove qualquer separador extra digitado depois
// do primeiro.
export const sanitizeDecimalKeystroke = (text) => {
    if (!text) return '';
    let out = text.replace(/[^0-9.,]/g, '');
    const firstSep = out.search(/[.,]/);
    if (firstSep !== -1) {
        out = out.slice(0, firstSep + 1) + out.slice(firstSep + 1).replace(/[.,]/g, '');
    }
    return out;
};

// Converte o texto digitado (com vírgula ou ponto) num Number válido pro
// backend, ou null se vazio/inválido.
export const parseDecimalInput = (text) => {
    if (text === null || text === undefined) return null;
    const cleaned = String(text).trim().replace(',', '.');
    if (cleaned === '') return null;
    const n = Number(cleaned);
    return Number.isNaN(n) ? null : n;
};
